export default __webpack_public_path__ + "static/media/token.d617ba49.svg";